import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "@/router/views/BaseMixer";
import { TagSaveModel } from "@/store/models/tag/tagSaveDTO";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
let TagUpsertComponent = /** @class */ (() => {
    var _a;
    let TagUpsertComponent = class TagUpsertComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isLoading = false;
        }
        showModal() {
            this.$bvModal.show("tag-modal");
        }
        saveTag() {
            this.validate("tagObserver").then((res) => {
                if (res) {
                    this.isLoading = true;
                    this.$emit("saveTag", this.tagDetail);
                }
            });
        }
        hideModal() {
            this.$bvModal.hide("tag-modal");
        }
        stopLoading() {
            this.isLoading = false;
            this.hideModal();
        }
        loading() {
            this.isLoading = false;
        }
        cancelTag() {
            this.$emit("cancel");
            this.hideModal();
        }
        created() { }
        destroyed() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], TagUpsertComponent.prototype, "title", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof TagSaveModel !== "undefined" && TagSaveModel) === "function" ? _a : Object)
    ], TagUpsertComponent.prototype, "tagDetail", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], TagUpsertComponent.prototype, "buttonName", void 0);
    TagUpsertComponent = __decorate([
        Component({
            name: "TagUpsertComponent",
            components: {
                SectionLoader,
            },
        })
    ], TagUpsertComponent);
    return TagUpsertComponent;
})();
export default TagUpsertComponent;
